import { Box, Button, CircularProgress, Grid } from '@material-ui/core';

import { Typography } from '@room-match/shared-ui-components';
import { ProfileImageCropper } from 'components/RegistrationForm/AdultForm/ProfileImageAdult/ProfileImageCropper';
import { useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import DownloadBanner from 'shared/components/DownloadBanner/DownloadBanner';
import { CONFIG } from 'shared/config';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IOutput, IProfile, IProfileMediaSetSelectPayload } from 'shared/interfaces/IProfile';
import { IOnProgress } from 'shared/interfaces/utils/IAxios';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { uploadService } from 'shared/services/uploadService';
import { errorResponseToArray } from 'shared/utils/room-shared';
import { ProgressOverlay, useStyles } from './Complete.styles';
import { ls } from 'shared/utils/ls';
const { setSelectProfileMedia, setProfilePrimaryImage } = profileService();

type Props = {
  info?: IProfile;
  selfTapes?: boolean;
};
const imageMimeType = /image\/(png|jpg|jpeg)/i;
const { updateMe } = talentService();
const { uploadMedia } = uploadService();

const Complete: React.FC<Props> = ({ info, selfTapes }) => {
  const classes = useStyles();
  const [file, setFile] = useState<File | null>(null);
  const [fileDataURL, setFileDataURL] = useState(null);
  const [cropper, setCropper] = useState<any>(null);
  const { mutateAsync: mutateAsyncUploadMedia, isLoading: isLoadingUploadMedia } = uploadMedia();
  const { mutateAsync: meUpdate, isLoading } = updateMe();
  const { mutate, mutateAsync } = setSelectProfileMedia();
  const { mutate: primaryImageMutate, isLoading: isSaving } = setProfilePrimaryImage();
  const skills = info?.attributes.talent.data.attributes.skills;
  const credits = info?.attributes.resume?.length || 0;
  const history = useHistory();
  const inputFile = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [completion, setcompletion] = useState(0);
  const [progress, setprogress] = useState(0);
  const queryClient = useQueryClient();
  const [uploadedURL, setURL] = useState('');
  const { width } = useWindowDimensions();
  const { removeLS } = ls();

  const skillsCount = () => {
    let count = 0;
    (skills || []).map((s) => {
      s.groups?.map((g) => {
        g.skills.map((s) => {
          if (s.is_selected) count++;
        });
      });
    });
    return count;
  };

  const [uploadedImg, setUploadedImg] = useState<{
    name: string;
    type: string;
    size: string;
    file: Blob | undefined;
    imageAttr: { width: number; height: number };
  } | null>(null);

  const profileId = info?.id || '';

  const changeHandler = (e: any) => {
    const file = e.target.files[0];
    if (!file?.type.match(imageMimeType)) {
      return;
    }
    setFile(file);

    let fileReader: any,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      const image = new Image();
      fileReader.onload = (e: any) => {
        const { result } = e.target;
        image.src = fileReader.result as string;
        setFileDataURL(result);
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  };

  const onProgres: IOnProgress = (progress: number) => {
    setprogress(progress);
  };

  const handleMakePrimary = (mediaId: string) => {
    const formData = new FormData();
    formData.set('medium_id', mediaId);

    primaryImageMutate(
      { profileId, formData },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['profile', profileId]);
          queryClient.removeQueries('profiles');
          queryClient.removeQueries('me');
          queryClient.removeQueries(['profile_primary_image', profileId]);
          queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
          setUploading(false);
        },
      },
    );
  };

  const bindToProfile = async (payload: IProfileMediaSetSelectPayload) => {
    await mutateAsync(
      { profileId, payload: { ...payload, sort: 0 } },
      {
        onError: (errors) => {
          if (errors?.response?.data?.errors) {
            const errorResponseArray: any = errorResponseToArray(errors.response.data.errors);
            console.error('error', errorResponseArray.join(','));
          } else {
            console.error('error', 'Something went wrong');
          }
        },
      },
    );
    queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
    queryClient.invalidateQueries(['media', { file_type: 'image' }]);
    handleMakePrimary(payload.id);
    setFileDataURL(null);
  };

  const handleUploadImg = async () => {
    setUploading(true);
    if (uploadedImg?.file) {
      const formData = new FormData();
      formData.append('attachment', uploadedImg.file);
      formData.append('file_name', uploadedImg.name);
      formData.append('file_width', uploadedImg.imageAttr.width.toString());
      formData.append('file_height', uploadedImg.imageAttr.height.toString());
      formData.append('file_size', uploadedImg.size);
      formData.append('file_type', uploadedImg.type);
      formData.append('media_bin', 'true');
      const uploadedPhoto = await mutateAsyncUploadMedia({ formData, onProgres });
      if (uploadedPhoto) {
        console.log({ uploadedPhoto });
        setURL(uploadedPhoto.data.attributes.attachment_url);
        meUpdate({ medium_id: uploadedPhoto.data.id }).then(() =>
          bindToProfile({
            id: uploadedPhoto.data.id,
            tag_list: 'image',
          }),
        );
      }
    }
  };

  const getCropData = (data: IOutput) => {
    console.log('called');

    setUploadedImg({
      name: file?.name || data.file_name,
      type: data.file_type,
      size: data.file_size,
      file: data.attachment,
      imageAttr: {
        width: parseInt(data.file_height),
        height: parseInt(data.file_height),
      },
    });
  };

  const progressOverlay = () => (
    <ProgressOverlay>
      <svg width="0" height="0">
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor="#39F" />
          <stop offset="90%" stopColor="#F3F" />
        </linearGradient>
      </svg>
      {progress === 100 ? (
        <CircularProgress thickness={3} classes={{ circle: classes.circle }} />
      ) : (
        <>
          <CircularProgress thickness={3} variant="determinate" value={progress} classes={{ circle: classes.circle }} />
          <Typography style={{ position: 'absolute', fontSize: 12 }}>{`${Math.round(progress)}%`}</Typography>
        </>
      )}
    </ProgressOverlay>
  );

  const handleOpenFileWindow = () => {
    if (inputFile.current) {
      inputFile.current.click();
    }
  };

  useEffect(() => {
    return () => removeLS('prev_url');
  }, []);

  return (
    <>
      <Grid item className={classes.root}>
        <Grid item>
          {info?.attributes.primary_image_url || uploadedURL ? (
            <Box component="div" className={classes.imgContainer}>
              <img src={` ${info?.attributes.primary_image_url || uploadedURL}`} className={classes.img} />
            </Box>
          ) : (
            <Box style={{ position: 'relative' }}>
              {uploading && progressOverlay()}
              <div style={{ height: 0, width: 0, overflow: 'hidden' }}>
                <input
                  ref={inputFile}
                  id="contained-input-file"
                  type="file"
                  accept="image/*"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => {
                    changeHandler(e);
                  }}
                />
              </div>
              <Box
                component="div"
                className={classes.imgContainer}
                style={{ maxWidth: 288, minWidth: 288, height: 405 }}
              >
                {fileDataURL === null ? (
                  <Box onClick={handleOpenFileWindow} style={{ width: '100%', height: '100%' }}>
                    <Typography
                      style={{
                        whiteSpace: 'normal',
                        fontSize: 18,
                        zIndex: 2,
                        position: 'absolute',
                        bottom: 15,
                        color: 'white',
                        right: 0,
                        left: 0,
                        width: '80%',
                        marginInline: 'auto',
                        fontWeight: 500,
                        marginBottom: 20,
                        background: COLORS.PRIMARY,
                        borderRadius: 8,
                        padding: '10px 25px',
                        border: '1px solid gray',
                      }}
                    >
                      Add your headshot
                    </Typography>
                    <img src={'/assets/user.png'} className={classes.img} style={{ position: 'absolute' }} />
                  </Box>
                ) : (
                  <ProfileImageCropper
                    src={fileDataURL ? fileDataURL : ''}
                    cropper={cropper}
                    setCropper={setCropper}
                    handleCrop={getCropData}
                  />
                )}
              </Box>
            </Box>
          )}

          {fileDataURL && (
            <>
              {width < 960 && (
                <Box component="div" className={classes.tooltipContainer}>
                  <Typography style={{ textAlign: 'center' }}>
                    You can pinch to zoom & drag to reposition inside the frame
                  </Typography>
                </Box>
              )}
              <Box>
                <Button
                  style={{ marginTop: width > 960 ? 70 : 20, marginBottom: 20, background: COLORS.GRAY }}
                  onClick={handleOpenFileWindow}
                >
                  Change Image
                </Button>
                <Button
                  style={{
                    marginTop: width > 960 ? 70 : 20,
                    marginBottom: 20,
                    background: COLORS.PRIMARY,
                    padding: '6px 45px',
                    marginLeft: 10,
                  }}
                  onClick={handleUploadImg}
                >
                  Save
                </Button>
              </Box>
            </>
          )}
          <p style={{ marginBottom: 5, fontSize: 18 }}>{info?.attributes.talent.data.attributes.stage_name}</p>
          <Typography color="primary">{info?.attributes.agency_name}</Typography>
        </Grid>
        <Grid item>
          <Grid item>
            <Typography fontSize={30} color="primary" className={classes.completeText}>
              {selfTapes ? '   Self-tape Complete' : 'Check-In Complete'}
            </Typography>
            <p style={{ fontSize: 18 }}>
              {selfTapes
                ? 'Thank you for your submission.'
                : 'Thank you for checking in, please wait to be called in for your audition.'}
            </p>
          </Grid>
          <Grid item className={classes.dataContainer}>
            <Typography color="primary" className={classes.dataHeading}>
              Current information appearing alongside your audition
            </Typography>
            <Grid item>
              <p style={{ fontSize: 15 }}>Media</p>
              <Typography fontSize={15} className={classes.slashes}>
                {info?.attributes.images.data.length || 0 > 0 || uploadedURL ? (
                  <Box component="span" className={classes.primary}>
                    {info?.attributes.images.data.length + uploadedURL ? 1 : 0} Image
                  </Box>
                ) : (
                  <Box component="span" className={classes.yellow}>
                    {uploadedURL ? '1 Image' : '0 Image'}
                  </Box>
                )}{' '}
                /{' '}
                {info?.attributes.videos.data.length || 0 > 0 ? (
                  <Box component="span" className={classes.primary}>
                    {info?.attributes.videos.data.length} Video
                  </Box>
                ) : (
                  <Box component="span" className={classes.yellow}>
                    0 Video
                  </Box>
                )}{' '}
                /{' '}
                {info?.attributes.audios.data.length || 0 > 0 ? (
                  <Box component="span" className={classes.primary}>
                    {info?.attributes.audios.data.length} Audio
                  </Box>
                ) : (
                  <Box component="span" className={classes.yellow}>
                    0 Audio
                  </Box>
                )}
              </Typography>
            </Grid>
            <Grid item>
              <p style={{ fontSize: 15 }}>Resume</p>
              <Typography fontSize={15}>
                {credits > 0 ? (
                  <Box component="span" className={classes.primary}>
                    {credits} Credits
                  </Box>
                ) : (
                  <Box component="span" className={classes.yellow}>
                    0 Credits
                  </Box>
                )}
              </Typography>
            </Grid>
            <Grid item>
              <p style={{ fontSize: 15 }}>Skills</p>
              <Typography fontSize={15}>
                <Box component="span" className={skillsCount() ? classes.primary : classes.yellow}>
                  {skillsCount()} Skills
                </Box>
              </Typography>
            </Grid>
          </Grid>
          <Grid item className={classes.btnContainer}>
            {CONFIG.APP_ENV !== 'production' && (
              <Button
                variant="outlined"
                fullWidth
                className={!info?.attributes.images.data || !!uploadedURL ? classes.primaryBtn : classes.secondaryBtn}
                onClick={() => history.push(`${ROUTES.TALENT.PROFILES}/${info?.id}`)}
                // onClick={() => history.push(`${ROUTES.TALENT.MEDIA}/dashboard`)}
              >
                {!info?.attributes.images.data || !!uploadedURL ? 'Update Media' : 'Add Media'}
              </Button>
            )}
            <Button
              variant="outlined"
              fullWidth
              className={skillsCount() ? classes.primaryBtn : classes.secondaryBtn}
              onClick={() => history.push(`${ROUTES.TALENT.MYINFO}/skills`)}
            >
              {skillsCount() ? 'Update Skills' : 'Add Skills'}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              className={credits ? classes.primaryBtn : classes.secondaryBtn}
              onClick={() => history.push(`${ROUTES.TALENT.MYINFO}/resume`)}
            >
              {credits ? 'Update Resume' : 'Add Resume'}
            </Button>
            <Button
              variant="outlined"
              fullWidth
              className={classes.secondaryBtn}
              onClick={() => history.push(`${ROUTES.TALENT.MYINFO}/size_card`)}
            >
              Update Size Card
            </Button>
          </Grid>
          <Grid item className={classes.dashboard}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => history.push(`${ROUTES.TALENT.DASHBOARD}`)}
            >
              Go To Dashboard
            </Button>

            {/* <Button
              disableElevation
              fullWidth
              className={classes.clearButton}
              onClick={() => setActiveStep(activeStep - 1)}
            >
              Go Back
            </Button> */}
          </Grid>
          <Grid item style={{ marginTop: 20 }}>
            <DownloadBanner />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Complete;
